import React, { createContext, useContext, useState, useCallback } from 'react';

const WorkspaceContext = createContext({
    title: null,
    setTitle: () => {},
    positionNav: null,
    setPositionNav: () => {},
});

export const WorkspaceProvider = ({ children }) => {
    const [title, setTitleState] = useState(null);
    // Job-position nav data published by the page currently on screen
    // (via the headless JobPositionNavigation bridge) and rendered by the
    // unified sidebar. Kept sticky across route transitions — the sidebar
    // matches it against the URL's jobPositionId before using it, so stale
    // data from a previously visited position is ignored rather than flashed.
    const [positionNav, setPositionNav] = useState(null);

    const setTitle = useCallback((newTitle) => {
        setTitleState(newTitle || null);
    }, []);

    return (
        <WorkspaceContext.Provider value={{ title, setTitle, positionNav, setPositionNav }}>
            {children}
        </WorkspaceContext.Provider>
    );
};

export const useWorkspace = () => useContext(WorkspaceContext);

export const useWorkspaceTitle = (title) => {
    const { setTitle } = useWorkspace();

    React.useEffect(() => {
        if (title) setTitle(title);
        return () => setTitle(null);
    }, [title, setTitle]);
};

export default WorkspaceContext;
